import '../_plugins/openClosePlugin';

// open-close init
export default function initOpenClose() {
	jQuery('.open-close-menu').openClose({
		activeClass: 'active',
		hideOnClickOutside: true,
		opener: '.open-close-menu__opener',
		slider: '.menu-drop',
		animSpeed: 400,
		effect: 'slide',
	});
}



// WEBPACK FOOTER //
// ./assets/scripts/js/_components/openClose.js